import * as req from 'api/actions';
import * as c from './constant';

export const getRequirementList = (payload, callback) => req.list(
  c.GET_REQUIREMENT_LIST,
  'api/v1/administrators/requirements',
  payload,
  callback,
);

export const getPermitTypeList = (payload, callback, type = 'OHP') => req.list(
  c.GET_PERMIT_TYPE_LIST,
  `api/v1/administrators/module_systems/${type}/application_statuses`,
  payload,
  callback,
);

export const updateApplicationRequirements = (payload, callback) => req.update(
  c.UPDATE_APPLICATION_REQUIREMENT,
  'api/v1/administrators/application_status_requirements/set',
  payload,
  callback,
);
